import { useState } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "ady_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem(CONSENT_KEY));

  const choose = (value) => {
    localStorage.setItem(CONSENT_KEY, value);
    setVisible(false);
    if (value === "accepted") window.__initAnalytics?.();
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[70] bg-[#111111] border-t-2 border-[#39FF14] px-4 sm:px-6 py-4"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="font-jet text-xs text-[#A1A1AA] leading-relaxed flex-1">
          Wir möchten Analyse-Cookies (PostHog) verwenden, um die Website zu verbessern.
          Ohne deine Zustimmung bleibt Tracking deaktiviert. Details in der{" "}
          <Link to="/datenschutz" className="text-[#39FF14]">Datenschutzerklärung</Link>.
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            data-testid="cookie-decline"
            onClick={() => choose("declined")}
            className="font-bebas tracking-[0.15em] text-sm px-5 py-2.5 border border-[#2A2A2A] text-[#A1A1AA] hover:border-[#A1A1AA] transition-colors uppercase bg-transparent cursor-pointer"
          >
            Ablehnen
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => choose("accepted")}
            className="font-bebas tracking-[0.15em] text-sm px-5 py-2.5 bg-[#39FF14] text-[#050505] hover:bg-[#2FD610] transition-colors uppercase border-none cursor-pointer"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};
